/**
 * Normalizes an issue key query by removing hyphens and spaces so that
 * queries like "AAA34", "AAA 34", and "AAA-34" all match the canonical key "AAA-34".
 * Returns undefined if the value does not look like an issue key.
 */
export const normalizeWorkItemKey = (value: string): string | undefined => {
	const normalized = value.replace(/^([a-zA-Z]+)[\s-]?(\d+)$/, '$1-$2').toLowerCase();
	return normalized !== value.toLowerCase() || /^[a-zA-Z]+-\d+$/.test(value)
		? normalized
		: undefined;
};
